import React from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";

const Regions = ({ regions, onSetRegions }) => {
  const addRegionField = () => {
    const newId = regions.length > 0 ? Math.max(...regions.map((r) => r.id)) + 1 : 1;
    onSetRegions([...regions, { id: newId, name: "" }]);
  };

  const deleteRegionField = (id) => {
    // prevent deleting if there's only one region
    if (regions.length <= 1) {
      return;
    }

    onSetRegions(regions.filter((region) => region.id !== id));
  };

  // handle region name changes
  const handleRegionChange = (id, value) => {
    onSetRegions(regions.map((region) => (region.id === id ? { ...region, name: value } : region)));
  };

  return (
    <div className="company-section mb-5 p-4 bg-light border rounded">
      <h5 className="text-white p-2" style={{ backgroundColor: "#243544" }}>
        Regions
      </h5>

      {regions.map((region, index) => (
        <Row key={region.id} className="mb-3">
          <Col xs={9}>
            <div className="d-flex">
              <Form.Control
                type="text"
                placeholder="Enter Region Name"
                value={region.name}
                onChange={(e) => handleRegionChange(region.id, e.target.value)}
                required
                className="me-2"
              />

              {index === regions.length - 1 && (
                <Button variant="outline-primary" onClick={addRegionField} className="d-flex align-items-center me-2">
                  <FontAwesomeIcon icon={faPlus} />
                </Button>
              )}

              {regions.length > 1 && (
                <Button variant="outline-danger" onClick={() => deleteRegionField(region.id)} className="d-flex align-items-center">
                  <FontAwesomeIcon icon={faTrash} />
                </Button>
              )}
            </div>
          </Col>
        </Row>
      ))}
    </div>
  );
};

export default Regions;
